// react-bootstrap imports
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import { useEffect, useState, useRef } from "react"
import { useLocation } from "react-router-dom"
import { Button, Form } from "react-bootstrap"

// assets imports
import stdStyle from "json/StdStyles.json"

// service imports
import * as service from "services/Simuladora/index"

// components imports
import { BotaoVoltar, LoadingSpinner } from "components/helpers"
import { DynamicInputFieldsV2 } from "services/InputFieldsTaxas"
import { determinaServicoEscolhido, resultsAreValid } from "services/CalcTaxaFunctions"
import { AlertMessage} from "components/AlertMessages"


import * as Links from "constants/links"
import { tipoImovelNome } from "constants/tiposImovel"
import * as SERVICOS from "constants/servicosTaxasV2"
import { useAlert } from "hooks/useAlert"

const InputFields = ({ idServ }) =>
{

    let fields = []

    const [areaConstMaior400, setAreaConstMaior400] = useState(false)
    const [executadaComLicenca, setExecutadaComLicenca] = useState(false)
    const [taxaOcupMenor30, setTaxaOcupMenor30] = useState(false)
    const [hasAnuencia, setHasAnuencia] = useState(false)
    const [hasAreaAverbada, setHasAreaAverbada] = useState(false)
    const [hasAreaAverbOuAprov, setHasAreaAverbOuAprov] = useState(false)
    const [hasAreaDemolSemAut, setHasAreaDemolSemAut] = useState(false)
    const [areaAverbadaTemOutroUso, setAreaAverbadaTemOutroUso] = useState(false)
    const [hasAreaConst, setHasAreaConst] = useState(false)
    const [hasNumUnid, setHasNumUnid] = useState(false)
    const [houveInicioDeObra, setHouveInicioDeObra] = useState(false)
    const [possuiDemarcacao, setPossuiDemarcacao] = useState(false)
    const [fatoGeradorProtocolo, setFatoGeradorProtocolo] = useState(false)
    const [tipoImovel, setTipoImovel] = useState()
    
    const onChangeAnuencia = () => {setHasAnuencia(!hasAnuencia)}
    const onChangeTipoImovel = () => {setTipoImovel(document.getElementsByName("tipoImovel")[0].value)}
    const onChangeTipoImovelVist = () => {
        const tipoImovelVist = document.getElementsByName("tipoImovel")[0].value
        const edifHasAreaConst = [tipoImovelNome.Uniresidencial, tipoImovelNome.NaoResidencial, tipoImovelNome.ERB, tipoImovelNome.GLP].includes(tipoImovelVist)
        const edifHasNumUnid = [tipoImovelNome.MultiresidencialAte4Pav, tipoImovelNome.MultiresidencialAcima4Pav, tipoImovelNome.CondominioLotes].includes(tipoImovelVist)
        setHasAreaConst(edifHasAreaConst)
        setHasNumUnid(edifHasNumUnid)
    }
    const onChangeTaxaOcupMenor30 = () => {setTaxaOcupMenor30(document.getElementsByName("taxaOcupMenor30")[0].checked)}
    const onChangeAreaConst = () => {setAreaConstMaior400(400 < document.getElementsByName("areaConstruida")[0].value)}
    const onChangeAreaAverb = () => {setHasAreaAverbada(0 < document.getElementsByName("areaAverbada")[0].value)}
    const onChangeAreaAverbOuAprov = () => {setHasAreaAverbOuAprov(0 < document.getElementsByName("areaAverbadaOuAprovada")[0].value)}
    const onChangePossuiLicenca = () => {setExecutadaComLicenca( 0 < document.getElementsByName("areaRegularizar")[0].value )}
    // const onChangeCondLotesTemComercio = () => {setCondLotesTemComercio(document.getElementsByName("temComercio")[0].checked)}
    const onChangePossuiDemarcacao = () => {setPossuiDemarcacao(document.getElementsByName("possuiDemarcacao")[0].checked)}
    const onChangeHouveInicioDeObra = () => {setHouveInicioDeObra(document.getElementsByName("houveInicioDeObra")[0].checked)}
    const onChangeTipoImovelAlvara = () => {onChangeTipoImovel() ; onChangeTipoImovelVist()}
    const onChangeFatoGeradorProtocolo = () => {setFatoGeradorProtocolo(document.getElementsByName("fatoGeradorProtocolo")[0].value)}
    const onChangeAreaAverbadaTemOutroUso = () => {setAreaAverbadaTemOutroUso(document.getElementsByName("tipoImovel")[0].value !== document.getElementsByName("usoAreaAverbada")[0].value)}
    const onChangeAreaDemolSemAut = () => {setHasAreaDemolSemAut(0 < document.getElementsByName("areaDemolidaSemAutorizacao")[0].value)}

    switch (idServ)
    {
        case "Alvara":
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"tipoImovelAlvara"} OnChange={onChangeTipoImovelAlvara} />)
            // fields.push(<DynamicInputFieldsV2 fieldName={"anuencia"} OnChange={onChangeAnuencia} />)
            fields.push(tipoImovel !== tipoImovelNome.Loteamento ? <DynamicInputFieldsV2 fieldName={"taxaOcupMenor30"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.Uniresidencial ? <DynamicInputFieldsV2 fieldName={"conjuntoHabitacional"} /> : <></>)
            fields.push((tipoImovel !== tipoImovelNome.ERB & tipoImovel !== tipoImovelNome.Loteamento) ? <DynamicInputFieldsV2 fieldName={"areaConstruida"} OnChange={onChangeAreaConst} /> : <></>)
            // fields.push(tipoImovel === "GLP" ? <DynamicInputFieldsV2 fieldName={"areaPlataforma"} /> : <></>)
            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav) ? <DynamicInputFieldsV2 fieldName={"areaUtil"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.ERB ? <DynamicInputFieldsV2 fieldName={"numEstacoes"} /> : <></>)
            fields.push(<DynamicInputFieldsV2 fieldName={"houveInicioDeObra"} OnChange={onChangeHouveInicioDeObra} />)
            fields.push(houveInicioDeObra ? <DynamicInputFieldsV2 fieldName={"obraEmExecucao"} /> : <></>)
            fields.push(houveInicioDeObra ? <DynamicInputFieldsV2 fieldName={"valorPagoInicioDeObra"} OnChange={onChangeHouveInicioDeObra} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.Loteamento ? <DynamicInputFieldsV2 fieldName={"areaTerreno"} /> : <></>)

            break
        }
        case "Anuencia":
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"tipoImovelAlvara"} OnChange={onChangeTipoImovelAlvara} />)
            fields.push((tipoImovel !== tipoImovelNome.ERB & tipoImovel !== tipoImovelNome.Loteamento) ? <DynamicInputFieldsV2 fieldName={"areaConstruida"} OnChange={onChangeAreaConst} /> : <></>)
            // fields.push(tipoImovel === "GLP" ? <DynamicInputFieldsV2 fieldName={"areaPlataforma"} /> : <></>)
            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav) ? <DynamicInputFieldsV2 fieldName={"areaUtil"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.ERB ? <DynamicInputFieldsV2 fieldName={"numEstacoes"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.Loteamento ? <DynamicInputFieldsV2 fieldName={"areaTerreno"} /> : <></>)

            break
        }
        case "AlvaraAcresReg":
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"tipoImovelAlvaraAcresReg"} OnChange={onChangeTipoImovelAlvara} />)
            // fields.push(<DynamicInputFieldsV2 fieldName={"anuencia"} OnChange={onChangeAnuencia} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"taxaOcupMenor30"} OnChange={onChangeHouveInicioDeObra} />)
            fields.push(tipoImovel === tipoImovelNome.Uniresidencial ? <DynamicInputFieldsV2 fieldName={"conjuntoHabitacional"} /> : <></>)
            fields.push(<DynamicInputFieldsV2 fieldName={"areaAcrescida"} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"areaReforma"} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"areaRegularizar"} OnChange={onChangePossuiLicenca} />)
            // fields.push(tipoImovel === "GLP" ? <DynamicInputFieldsV2 fieldName={"areaPlataforma"} /> : <></>)

            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav) ? <DynamicInputFieldsV2 fieldName={"areaUtil"} /> : <></>)
            fields.push(tipoImovel !== tipoImovelNome.ERB ? <DynamicInputFieldsV2 fieldName={"areaConstruida"} OnChange={onChangeAreaConst} /> : <></>)

            fields.push(<DynamicInputFieldsV2 fieldName={"areaAverbada"} OnChange={onChangeAreaAverb}/>)
            fields.push(hasAreaAverbada ? <DynamicInputFieldsV2 fieldName={"usoAreaAverbada"} /> : <></>)
            fields.push(executadaComLicenca ? <DynamicInputFieldsV2 fieldName={"executadaComLicenca"} /> : <></>)
            fields.push(<DynamicInputFieldsV2 fieldName={"houveInicioDeObra"} OnChange={onChangeHouveInicioDeObra} />)
            fields.push(houveInicioDeObra ? <DynamicInputFieldsV2 fieldName={"obraEmExecucao"} /> : <></>)
            fields.push(houveInicioDeObra ? <DynamicInputFieldsV2 fieldName={"valorPagoInicioDeObra"} OnChange={onChangeHouveInicioDeObra} /> : <></>)

            break
        }
        case "AutERB": fields.push(<DynamicInputFieldsV2 fieldName={"numEstacoes"} />); break
        case "AutoDeEmbargo": case "ReparosGeraisSemLicenca": 
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"diasAposVencimento"} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"usoComplexo"} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"usoIncomodo"} />)
            break
        }
        case "AutoDeInfracao":
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"diasAposVencimento"} />)
            // fields.push(<DynamicInputFieldsV2 fieldName={"usoComplexo"} />)
            // fields.push(<DynamicInputFieldsV2 fieldName={"usoIncomodo"} />)
            // fields.push(<DynamicInputFieldsV2 fieldName={"areaDemolidaSemAutorizacao"} OnChange={onChangeAreaDemolSemAut} />)
            // if (hasAreaDemolSemAut)
            // {
            //     fields.push(<DynamicInputFieldsV2 fieldName={"tiposImovelObraIniciadaSemLicenca"} OnChange={onChangeTipoImovelAlvara} />)
            //     fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav) ? <DynamicInputFieldsV2 fieldName={"areaUtil"} /> : <></>)
            // }
            break
        }
        case "AutRepGerais": case "AutRepGeraisAcess": fields.push(<DynamicInputFieldsV2 fieldName={"houveInicioDeObra"} />); break
        case "AutObrasInfra":
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"valorContrato"} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"houveInicioDeObra"} />)

            break
        }
        case "CertDemolSemAut":
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"tiposImovelObraIniciadaSemLicenca"} OnChange={onChangeTipoImovelAlvara} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"areaDemolidaSemAutorizacao"} />)
            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav) ? <DynamicInputFieldsV2 fieldName={"areaUtil"} /> : <></>)

            break
        }
        case "CertHabitese": case "RenHabitese":
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"tipoImovelHabitese"} OnChange={onChangeTipoImovelAlvara} />)
            fields.push(tipoImovel === tipoImovelNome.MultiresidencialAte4Pav ? <DynamicInputFieldsV2 fieldName={"tipoCondominio"} /> : <></>)
            fields.push(hasAreaConst ? <DynamicInputFieldsV2 fieldName={"areaConstruida"} /> : <></>)
            fields.push(hasNumUnid ? <DynamicInputFieldsV2 fieldName={"numUnid"} /> : <></>)
            //fields.push(tipoImovel === tipoImovelNome.CondominioLotes ? <DynamicInputFieldsV2 fieldName={"numLotes"} /> : <></>)
            if (tipoImovel === tipoImovelNome.CondominioLotes & document.getElementsByName("temComercio")[0] !== undefined)
            {
                fields.push(document.getElementsByName("temComercio")[0].checked ? <DynamicInputFieldsV2 fieldName={"areaConstruidaComercio"} /> : <></>)
            }
            fields.push(<DynamicInputFieldsV2 fieldName={"qtdVistorias"} />)

            break
        }
        case "CertRegul":
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"tipoImovelAlvara"} OnChange={onChangeTipoImovelAlvara} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"executadaComLicenca"} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"imovelEhTemplo"} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"imovelEhInstituicaoDeCaridade"} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"cidadaoBaixaRenda"} />)
            fields.push(tipoImovel === tipoImovelNome.Uniresidencial ? <DynamicInputFieldsV2 fieldName={"conjuntoHabitacional"} /> : <></>)
            fields.push(tipoImovel !== tipoImovelNome.Loteamento ? <DynamicInputFieldsV2 fieldName={"taxaOcupMenor30"} /> : <></>)
            fields.push(tipoImovel !== tipoImovelNome.Loteamento ? <DynamicInputFieldsV2 fieldName={"atendeAsNormasUrb"} /> : <></>)
            fields.push((tipoImovel !== tipoImovelNome.ERB & tipoImovel !== tipoImovelNome.Loteamento) ? <DynamicInputFieldsV2 fieldName={"areaConstruida"} OnChange={onChangeAreaConst} /> : <></>)
            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav) ? <DynamicInputFieldsV2 fieldName={"areaUtil"} /> : <></>)
            // fields.push(tipoImovel === tipoImovelNome.GLP ? <DynamicInputFieldsV2 fieldName={"areaPlataforma"} /> : <></>)
            fields.push(tipoImovel !== tipoImovelNome.Loteamento ? <DynamicInputFieldsV2 fieldName={"areaRegularizar"} OnChange={onChangePossuiLicenca} /> : <></>)
            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav | tipoImovel === tipoImovelNome.CondominioLotes) ? <DynamicInputFieldsV2 fieldName={"numUnid"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.MultiresidencialAte4Pav ? <DynamicInputFieldsV2 fieldName={"tipoCondominio"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.Loteamento ? <DynamicInputFieldsV2 fieldName={"areaTerreno"} /> : <></>)
            fields.push(tipoImovel !== tipoImovelNome.Loteamento ? <DynamicInputFieldsV2 fieldName={"areaAverbadaOuAprovada"} OnChange={onChangeAreaAverbOuAprov}/> : <></>)
            fields.push(hasAreaAverbOuAprov ? <DynamicInputFieldsV2 fieldName={"usoAreaAverbada"}  OnChange={onChangeAreaAverbadaTemOutroUso}/> : <></>)

            if (hasAreaAverbOuAprov & document.getElementsByName("usoAreaAverbada")[0] !== undefined)
            {
                fields.push(areaAverbadaTemOutroUso ? <DynamicInputFieldsV2 fieldName={"areaAverbadaComMudancaDeUso"} /> : <></>)
                fields.push(<DynamicInputFieldsV2 fieldName={"mudancaUsoNaoGerouReforma"} />)
            }
            fields.push(<DynamicInputFieldsV2 fieldName={"qtdVistorias"} />)

            break
        }
        case "CertRegulInfra":
        {            
            fields.push(<DynamicInputFieldsV2 fieldName={"valorContrato"} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"houveInicioDeObra"} />)

            break
        }
        case "DeclConcInstERBSemAut":
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"numEstacoes"} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"atendeAsNormasUrb"} />)

            break
        }
        case "DeclGLP": fields.push(<DynamicInputFieldsV2 fieldName={"areaPlataforma"} />); break        
        case "Protocolo":
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"fatoGeradorProtocolo"} OnChange={onChangeFatoGeradorProtocolo} />)
            if (SERVICOS.comTipoUso.includes(fatoGeradorProtocolo))
            {
                fields.push(<DynamicInputFieldsV2 fieldName={"subTipoDoc"} />)
            }
            break      
        }
       case "ObraIniciadaSemLicenca":
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"tiposImovelObraIniciadaSemLicenca"} OnChange={onChangeTipoImovelAlvara} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"obraEmExecucao"} />)
            fields.push((tipoImovel !== tipoImovelNome.ERB && tipoImovel !== tipoImovelNome.GLP && tipoImovel !== tipoImovelNome.Loteamento) ? <DynamicInputFieldsV2 fieldName={"areaConstruida"} OnChange={onChangeAreaConst} /> : <></>)
            // fields.push(tipoImovel === "GLP" ? <DynamicInputFieldsV2 fieldName={"areaPlataforma"} /> : <></>)
            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav) ? <DynamicInputFieldsV2 fieldName={"areaUtil"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.ERB ? <DynamicInputFieldsV2 fieldName={"numEstacoes"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.Loteamento ? <DynamicInputFieldsV2 fieldName={"areaTerreno"} /> : <></>)
            fields.push(tipoImovel !== tipoImovelNome.ERB ? <DynamicInputFieldsV2 fieldName={"areaAcrescida"} /> : <></>)
            // fields.push(<DynamicInputFieldsV2 fieldName={"diasAposVencimento"} />)

            break
        }
        case "SubsProj":
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"tipoImovelAlvara"} OnChange={onChangeTipoImovelAlvara} />)
            fields.push(tipoImovel !== tipoImovelNome.Loteamento ? <DynamicInputFieldsV2 fieldName={"taxaOcupMenor30"} OnChange={onChangeTaxaOcupMenor30} /> : <></>)
            fields.push(tipoImovel !== tipoImovelNome.Loteamento && !taxaOcupMenor30 ? <DynamicInputFieldsV2 fieldName={"novaTaxaOcupMaior30"} /> : <></>)
            fields.push(tipoImovel !== tipoImovelNome.Loteamento ? <DynamicInputFieldsV2 fieldName={"areaConstruidaAprovada"} OnChange={onChangeAreaConst} /> : <></>)
            // fields.push(<DynamicInputFieldsV2 fieldName={"valorAlvara"} />)
            fields.push(tipoImovel !== tipoImovelNome.Loteamento ? <DynamicInputFieldsV2 fieldName={"areaAcrescidaDeConstrucao"} /> : <></>)
            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav) ? <DynamicInputFieldsV2 fieldName={"areaUtil"} /> : <></>)
            fields.push((tipoImovel === tipoImovelNome.MultiresidencialAte4Pav | tipoImovel === tipoImovelNome.MultiresidencialAcima4Pav) ? <DynamicInputFieldsV2 fieldName={"areaUtilAcrescida"} /> : <></>)
            // fields.push(tipoImovel === "GLP" ? <DynamicInputFieldsV2 fieldName={"areaAcrescidaPlataforma"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.Loteamento ? <DynamicInputFieldsV2 fieldName={"areaTerreno"} /> : <></>)
            fields.push(tipoImovel === tipoImovelNome.Loteamento ? <DynamicInputFieldsV2 fieldName={"areaTerrenoAcrescida"} /> : <></>)

            break
        }
        case "RenAlvara": fields.push(<DynamicInputFieldsV2 fieldName={"valorAlvara"} />); break
        case "TermoDemarc":
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"areaTerreno"} />)
            //fields.push(<DynamicInputFieldsV2 fieldName={"incluirTaxaDemarcacao"} />)
            break
        }
        case "TermoPermUsoEspacoPublico": fields.push(<DynamicInputFieldsV2 fieldName={"numVagas"} />); break
        case "TermoDesm": case "TermoRem": case "TermoDesmRem": case "TermoDesmComIncorporacao":
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"areaTerreno"} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"areaRemanescente"} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"possuiDemarcacao"} OnChange = {onChangePossuiDemarcacao} />)
            // fields.push(possuiDemarcacao ? <DynamicInputFieldsV2 fieldName={"testada"} /> : <></>)

            break
        }
        case "TermoVerObras": 
        {
            fields.push(<DynamicInputFieldsV2 fieldName={"numUnid"} />)
            fields.push(<DynamicInputFieldsV2 fieldName={"qtdVistorias"} />)
            break
        }
        default: break
    }

    fields.push(hasAnuencia ? <DynamicInputFieldsV2 fieldName={"valorAnuencia"} /> : <></>)

    if (tipoImovel === tipoImovelNome.CondominioLotes)
    {
        fields.push(idServ !== "SubsProj" & idServ !== "CertHabitese" & idServ !== "RenHabitese" & idServ !== "AlvaraAcresReg" ? <DynamicInputFieldsV2 fieldName={"areaTerreno"} /> : <></>)
    }

    fields = fields.filter((value) => {return value !== null})
    fields = fields.filter((field) => {return field.props.fieldName !== undefined})
    
    return  <div className="d-flex flex-column m-auto">{fields.map(field => <div key={field.props.fieldName}>{field}</div>)}</div>
}

const InputScreen = ({ idServ, nomeServ, taxaFixa }) =>
{
    const instrucoes = !taxaFixa ?
        <>
            <small className="text-muted mb-0 fs-7">* indica campos com preenchimento obrigatório</small>
            <small className="text-muted mb-3 fs-7">obs.: use ponto (e não vírgula) para números decimais</small>
        </> : <></>

    return (
        <div className = "d-flex flex-column py-3">
            <p className="fw-bold text-center fs-6">{nomeServ}</p>
            {instrucoes}
            <InputFields idServ={idServ} />
        </div>
    )
}

const OutputScreen = ({ results }) =>
{
    if (results === null | results === undefined) { console.log("Erro: tentando mostrar resultados da taxa com resultados indefinidos") ; return }

    const titleStyle = "fw-bold fs-6 text-primary"
    const contentStyle = "fs-6 text-primary"
    const obsStyle = "fs-6 text-muted"
    const totalTax = Number(0 < results.taxaTotal ? results.taxaTotal : 0).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
    const detCalc = results.detalhesDoCalculo //?? ""
    const detAval = results.detalhesDaAvaliacao //?? ""
    const metCalc = results.metodoDeCalculo //?? ""
    const obsDetCalc = results.obsDetCalc //?? ""
    const obsTaxaTotal = results.obsTaxaTotal //?? ""

    if (results.status === 500) { console.log("Erro: resultado das taxas retornado com status 500") ; return }

    return(
        <div className="d-flex flex-column mt-3 align-items-center">
            <p className={titleStyle}><u>Resultados da avaliação</u></p>

            <hr className="w-75" />
            <p className={titleStyle}><u>Taxa total</u></p>
            <p className={contentStyle}>Taxa total = {totalTax}</p>
            {obsTaxaTotal !== null ? <p className={obsStyle}>{obsTaxaTotal}</p> : <></>}
            <hr className="w-75" />

            <p className={titleStyle}><u>Detalhes do cálculo</u></p>
            {Object.keys(detCalc).map(det => detCalc[det] !== undefined ? <p className={contentStyle} key={det}>{detCalc[det]}</p> : <></>)}            
            {obsDetCalc !== null ? <p className={obsStyle}>{obsDetCalc}</p> : <></>}

            <p className={titleStyle}><u>Detalhes da avaliação</u></p>
            {Object.keys(detAval).map(det => <p className={contentStyle} key={det}>{detAval[det]}</p>)}

            <p className={titleStyle}><u>Método de cálculo</u></p>
            {
                detCalc["$taxaBasica$"] === "0.0" ?
                <></> :
                Object.keys(metCalc).map(met => <p className={contentStyle} key={met}>{metCalc[met]}</p>)
            }
        </div>
    )
}

const BotoesCalcularVoltar = ({ isLoading, target }) =>
{
    return (
        <div className="d-flex justify-content-around mb-2" >
            <BotaoVoltar linkPrevPage={Links.SERVICOS_TAXAS_CTM24} />
            <Button className={stdStyle.button} variant="success" type="submit" ref={target} disabled={isLoading}>{!isLoading ? "Calcular" : "Calculando"}</Button>                
        </div>
    )
}

export function SimuladoraScreen()
{
    const {alert, showAlert, closeAlert} = useAlert()
    const location = useLocation()
    const servico = location.state
    const { idServ, nomeServ, taxaFixa } = determinaServicoEscolhido(servico, SERVICOS.SERVICOSTAXAS)

    const target = useRef(null)
    const [results, setResults] = useState(null)
    const [isLoading, setLoading] = useState(false)
    const [validated, setValidated] = useState(false)

    const onFormSubmit = async event => {  
        service.handleSubmit(event, idServ, setLoading, setValidated, setResults, showAlert)
    }

    useEffect(() => {
        service.autoClick(taxaFixa)
    }, [taxaFixa])

    return (
        <>
            <LoadingSpinner show={isLoading} />
            <AlertMessage show={alert.show} variant={alert.variant} header={alert.header} message={alert.message} onClose={closeAlert} />

            <Form className={stdStyle.taxForm} noValidate validated={validated} onSubmit={onFormSubmit}  >

                <InputScreen idServ={idServ} nomeServ={nomeServ} taxaFixa={taxaFixa} />
                {resultsAreValid(results) ? <OutputScreen results={results} /> : <></>}
                <BotoesCalcularVoltar isLoading={isLoading} target={target} />

            </Form>
        </>
    )
}